import { ErrorResponse, Uuid } from 'ValueObjects';
import axios, { AxiosError, AxiosResponse } from 'axios';
import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from '@tanstack/react-query';

export type DeleteUserMutationProps = {
  userId: Uuid;
};

export const DeleteUserMutation = async ({
  ...values
}: DeleteUserMutationProps): Promise<AxiosResponse> =>
  axios.put(`api/users/${values.userId}/delete`, {
    ...values,
  });

export const useDeleteUserMutation = (
  options: UseMutationOptions<
    AxiosResponse,
    AxiosError<ErrorResponse>,
    DeleteUserMutationProps
  > = {}
): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorResponse>,
  DeleteUserMutationProps
> =>
  useMutation<
    AxiosResponse,
    AxiosError<ErrorResponse>,
    DeleteUserMutationProps
  >(DeleteUserMutation, {
    useErrorBoundary: false,
    ...options,
  });
